import withStyles from '@material-ui/core/styles/withStyles'

export default withStyles(theme => {
  return {
    step: {},
    icon: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 29,
      height: 29,
      marginRight: 24,
      border: 'solid 1px rgba(136, 102, 255, 0.2)',
      position: 'relative',
      borderRadius: '100%',
    },
    label: {
      display: 'flex',
    },
    content: {
      paddingLeft: 37,
      marginLeft: 14,
      paddingTop: 24,
      paddingBottom: 24,
      borderLeft: 'solid 1px rgba(136, 102, 255, 0.2)',
    },
    contentActive: {
      paddingTop: 0,
    },
    contentError: {
      marginLeft: 0,
      paddingLeft: 0,
      borderLeft: 0,
    },
    error: {
      whiteSpace: 'pre-line',
      marginBottom: 24,
      fontSize: 12,
      lineHeight: 1.5,
      color: 'rgb(255, 78, 68)',
    },
    iconActive: {
      border: 'solid 1px rgba(136, 102, 255)',
    },
    iconFinish: {
      border: 'solid 1px rgba(255, 204, 0)',
    },
    titleFinish: {
      display: 'block',
      fontSize: 24,
      fontWeight: 'bold',
      lineHeight: 1.13,
      color: 'rgb(0, 0, 0)',
    },
    subTitleFinish: {
      display: 'block',
      fontSize: 16,
      lineHeight: 1.5,
      color: 'rgb(0, 0, 0)',
    },
    errorHeading: {
      fontSize: 18,
      lineHeight: 1.5,
      color: '#ff4e44',
      whiteSpace: 'pre-line',
      marginTop: 24,
    },
    errorSeparator: {
      width: '100%',
      height: 1,
      margin: '24px 0',
      backgroundColor: '#ff4e44',
    },
    errorMessage: {
      display: 'block',
      fontSize: 16,
      fontWeight: 'bold',
      lineHeight: 1.5,
      color: '#ff4e44',
      marginLeft: 10,
    },
  }
})
